import { ParsedUrlQuery } from 'querystring';

import React from 'react';

import type {
  InferGetServerSidePropsType,
  GetServerSideProps,
  GetServerSidePropsContext,
  PreviewData,
} from 'next';

import {
  ConsentTag,
  consentTagC,
} from '@hooks/api/useStepState/types/fundingForm';
import { Document } from '@templates/Legal/Document';
import { propsWithWrappers } from '@utils/getServerSideProps/propsWithWrappers';

const LegalDocumentPage: React.FC<LegalDocumentPageProps> = ({ tag }) => {
  return <Document tag={tag} />;
};

type LegalDocumentPageProps = InferGetServerSidePropsType<
  typeof getServerSideProps
>;

const ourGetServerSideProps: GetServerSideProps<{
  tag: ConsentTag;
}> = async (sc: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>) => {
  const documentNameValidation = consentTagC.safeParse(sc.query.documentName);

  if (documentNameValidation.success) {
    return { props: { tag: documentNameValidation.data } };
  }

  return { notFound: true };
};

export const getServerSideProps = propsWithWrappers(ourGetServerSideProps);

export default LegalDocumentPage;
